<template>
    <FormSection title="Health History" :full-height="false">
        <template #content>
            <div class="form-group col-10 px-4 py-2">
                <h6 for="patient-smoking-status"><b>Current Smoking Status</b></h6>
                <div class="col-12 row g-0">
                    <div class="col-12 col-lg-4 pe-lg-3">
                        <label for="patient-smoking-status"> Smoking Status </label>
                        <select
                            class="form-select"
                            v-model="patient.smokingStatus"
                            @change="smokingStatusChanged(patient.smokingStatus)"
                        >
                            <option :value="0">Select Smoking Status</option>
                            <option v-for="[key, value] of enumToMap(smokingStatusEnum)" :value="value.value">
                                {{ value.name }}
                            </option>
                        </select>
                    </div>
                    <div
                        class="form-group col-12 col-lg-3 pe-lg-3"
                        v-if="
                            !(
                                patient.smokingStatus === 0 ||
                                patient.smokingStatus === smokingStatusEnum.enum.NeverSmoker ||
                                patient.smokingStatus === smokingStatusEnum.enum.UnknownIfEverSmoked
                            )
                        "
                    >
                        <label for="patient--smoking-status">
                            Start Date
                            <span class="text-danger">*</span>
                        </label>
                        <DatePicker :getDate="smokingDateChanged">
                            <div class="input-group date datepickerInput">
                                <input
                                    name="smokingStartDate"
                                    id="Smoking_Start_Date"
                                    type="text"
                                    class="form-control"
                                    placeholder="MM/DD/YYYY"
                                    :value="formatDateInput(patient.smokingStartDate)"
                                    @change="handleDateChange"
                                    autocomplete="off"
                                    @blur="v$.patient.smokingStartDate.$touch"
                                    :class="`${!v$.patient.smokingStartDate.$error ? '' : 'field-invalid'}`"
                                />
                                <div class="input-group-addon input-group-append">
                                    <div class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                                <span v-if="v$.patient.smokingStartDate.$error" class="field-invalid"
                                    >Smoking Start Date is required.</span
                                >
                            </div>
                        </DatePicker>
                    </div>
                    <div
                        class="col-12 col-lg-3 pe-lg-3"
                        v-if="
                            !(
                                patient.smokingStatus === 0 ||
                                patient.smokingStatus === smokingStatusEnum.enum.NeverSmoker ||
                                patient.smokingStatus === smokingStatusEnum.enum.UnknownIfEverSmoked
                            )
                        "
                    >
                        <label for="patient-smoking-status"> Stop Date </label>
                        <DatePicker :getDate="smokingDateChanged">
                            <div class="input-group date datepickerInput">
                                <input
                                    name="smokingEndDate"
                                    id="Smoking_End_Date"
                                    type="text"
                                    class="form-control"
                                    placeholder="MM/DD/YYYY"
                                    :value="formatDateInput(patient.smokingEndDate)"
                                    @change="handleDateChange"
                                    autocomplete="off"
                                />
                                <div class="input-group-addon input-group-append">
                                    <div class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                            </div>
                        </DatePicker>
                    </div>
                </div>
            </div>
        </template>
        <template #content_2>
            <div class="form-group col-10 px-3 offset-md-1 row g-0 au-target">
                <h6 for="patient-historical-smoking-status"><b>Historical Smoking Status</b></h6>
                <div class="col-12 row g-0">
                    <div class="col-12 col-lg-4 pe-lg-3">
                        <label for="patient-smoking-status"> Smoking Status </label>
                        <select
                            class="form-select"
                            v-model="patient.historicalSmokingStatus"
                            @change="historicalSmokingStatusChanged(patient.historicalSmokingStatus)"
                        >
                            <option :value="0">Select Smoking Status</option>
                            <option v-for="[key, value] of enumToMap(smokingStatusEnum)" :value="value.value">
                                {{ value.name }}
                            </option>
                        </select>
                    </div>
                    <div
                        class="col-12 col-lg-3 pe-lg-3"
                        v-if="
                            !(
                                patient.historicalSmokingStatus === 0 ||
                                patient.historicalSmokingStatus === smokingStatusEnum.enum.NeverSmoker ||
                                patient.historicalSmokingStatus === smokingStatusEnum.enum.UnknownIfEverSmoked
                            )
                        "
                    >
                        <label for="patient-historical-smoking-status">
                            Start Date<span class="text-danger">*</span>
                        </label>
                        <DatePicker :getDate="smokingDateChanged">
                            <div class="input-group date datepickerInput">
                                <input
                                    name="historicalSmokingStartDate"
                                    id="Historical_Smoking_Start_Date"
                                    type="text"
                                    class="form-control"
                                    placeholder="MM/DD/YYYY"
                                    :value="formatDateInput(patient.historicalSmokingStartDate)"
                                    @change="handleDateChange"
                                    autocomplete="off"
                                    @blur="v$.patient.historicalSmokingStartDate.$touch"
                                    :class="`${!v$.patient.historicalSmokingStartDate.$error ? '' : 'field-invalid'}`"
                                />
                                <div class="input-group-addon input-group-append">
                                    <div class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                                <span v-if="v$.patient.historicalSmokingStartDate.$error" class="field-invalid"
                                    >Historical Smoking Start Date is required.</span
                                >
                            </div>
                        </DatePicker>
                    </div>
                    <div
                        class="col-12 col-lg-3 pe-lg-3"
                        v-if="
                            !(
                                patient.historicalSmokingStatus === 0 ||
                                patient.historicalSmokingStatus === smokingStatusEnum.enum.NeverSmoker ||
                                patient.historicalSmokingStatus === smokingStatusEnum.enum.UnknownIfEverSmoked
                            )
                        "
                    >
                        <label for="patient-historical-smoking-status">
                            Stop Date<span class="text-danger">*</span>
                        </label>
                        <DatePicker :getDate="smokingDateChanged">
                            <div class="input-group date datepickerInput">
                                <input
                                    name="historicalSmokingEndDate"
                                    id="Historical_Smoking_End_Date"
                                    type="text"
                                    class="form-control"
                                    placeholder="MM/DD/YYYY"
                                    :value="formatDateInput(patient.historicalSmokingEndDate)"
                                    @change="handleDateChange"
                                    autocomplete="off"
                                    @blur="v$.patient.historicalSmokingEndDate.$touch"
                                    :class="`${!v$.patient.historicalSmokingEndDate.$error ? '' : 'field-invalid'}`"
                                />
                                <div class="input-group-addon input-group-append">
                                    <div class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                                <span v-if="v$.patient.historicalSmokingEndDate.$error" class="field-invalid"
                                    >Historical Smoking End Date is required.</span
                                >
                            </div>
                        </DatePicker>
                    </div>
                </div>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./PatientHealthHistory.ts"></script>
